import { render, staticRenderFns } from "./CashPosition.vue?vue&type=template&id=0b8a40b5&"
import script from "./CashPosition.vue?vue&type=script&lang=js&"
export * from "./CashPosition.vue?vue&type=script&lang=js&"
import style0 from "./CashPosition.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports